import { usePreferences } from '../hooks/usePreferences';
import en, { type TranslationKey, type Translations } from './en';
import he from './he';

export type Locale = 'en' | 'he';

const translations: Record<Locale, Translations> = { en, he };

const RTL_LOCALES: Set<Locale> = new Set(['he']);

export type { TranslationKey };

export function useTranslation() {
    const { preferences } = usePreferences();
    const locale = (preferences.locale as Locale) || 'en';
    const dict = translations[locale] ?? translations.en;
    const dir = RTL_LOCALES.has(locale) ? 'rtl' : 'ltr';

    function t(key: TranslationKey, vars?: Record<string, string | number>): string {
        let s = dict[key] ?? translations.en[key] ?? key;
        if (vars) {
            for (const [k, v] of Object.entries(vars)) {
                s = s.replaceAll(`{${k}}`, String(v));
            }
        }
        return s;
    }

    return { t, locale, dir } as const;
}

/** Non-hook translation helper for class components. Reads locale from <html> lang. */
export function getTranslation(key: TranslationKey): string {
    const lang = document.documentElement.lang || 'en';
    const locale = (lang as Locale) in translations ? (lang as Locale) : 'en';
    const dict = translations[locale];
    return dict[key] ?? translations.en[key] ?? key;
}
